jQuery(function ($) {
  // Nav Menu
  // Navbar Submenu Dropdown Links Click - Mobile
  $(".menu-toggle").on("click", function (e) {
    $(this).toggleClass("collapsed");

    var $subMenu = $(this).parent().next(".sub-menu");
    $subMenu.toggleClass("slideInUp animated show");

    return false;
  });

  // Contact Form 7 Placeholder Hide on Focus
  $("input,textarea")
    .focus(function () {
      $(this)
        .data("placeholder", $(this).attr("placeholder"))
        .attr("placeholder", "");
    })
    .blur(function () {
      $(this).attr("placeholder", $(this).data("placeholder"));
    });

  // Back To Top Button
  $(window).on("scroll", function () {
    if ($(this).scrollTop() > 200) {
      $(".backtotop").fadeIn();
    } else {
      $(".backtotop").fadeOut();
    }
  });

  $(".backtotop").on("click", function () {
    $("html, body").animate({ scrollTop: 0 }, 600);
    return false;
  });




$(".header__mobile-btn").on("click", function () {
  $(".header").toggleClass("open");
});
$(".header__mobile-overlay").on("click", function () {
  $(".header").removeClass("open");
});

$(".js-add-comment").on("click", function () {
  $(".popup--review").addClass("active");
});
$(".js-close-popup").on("click", function () {
  $(".popup").removeClass("active");
});

$(document).on("click", ".faq__head", function () {
  var _this = this;

  if (!$(this).parents(".faq__item").hasClass("active")) {
    $(".faq__item").removeClass("active");
    $(".faq__item-body").slideUp();
  }
  $(this).parents(".faq__item").toggleClass("active");
  $(this).next(".faq__item-body").slideToggle();
  if ($(window).width() < 767) {
    setTimeout(function () {
      $("html, body").animate(
        {
          scrollTop: $(_this).parents(".faq__item").offset().top - 60,
        },
        1000
      );
    }, 500);
  }
});

$(window).on("scroll", function () {
  var heightWindow = 100;
  if ($(this).scrollTop() >= heightWindow) {
    $("body").addClass("body--scroll");
  } else {
    $("body").removeClass("body--scroll");
  }
});

$(".js-country").on("click", function (event) {
  event.stopPropagation();
  $(this).parents(".js-country-parent").toggleClass("active");
});

$(document).on("click", function (event) {
  event.stopPropagation();
  if ($(event.target).closest(".js-country-list").length) return;
  $(".js-country-parent").removeClass("active");
});

$(".init-select2").each(function (index, element) {
  $(element).select2({
    minimumResultsForSearch: -1,
    dropdownParent: $(element).parents(".select2-parent"),
    templateResult: formatState,
    templateSelection: formatState,
  });
  function formatState(opt) {
    if (!opt.id) {
      return opt.text;
    }

    var hostURL = window.location.protocol + "//" + window.location.host + "/";

    var baseURL = hostURL + "wp-content/themes/acebet99/assets/images/";

    var $opt = $(
      '<span class="select-img"><img src="' +
        baseURL +
        opt.text.toUpperCase() +
        '.png" width="18" height="12" alt="country" /> ' +
        '<span class="select-text">' +
        opt.text +
        "</span>" +
        "</span>"
    );
    return $opt;
  }
});

$(".grid").masonry({
  itemSelector: ".grid-item",
  horizontalOrder: true,
  columnWidth: 333,
  gutter: 40,
});

});


// $(window).on("load resize", function () {
//   if ($(window).width() < 1200) {
//     // $(".header__mobile-box").append($(".header__form"));
//     // $(".header__mobile-box").append($(".header__nav"));
//     // $(".header__mobile-box").append($(".header__contacts"));
//     // $(".header__mobile-box").append($(".header__btn"));
//   } else {
//     $(".header__form").insertBefore($(".header__country"));
//     $(".header__holder").append($(".header__nav"));
//     $(".header__contacts").insertAfter($(".header__country"));
//     $(".header__btn").insertAfter($(".header__contacts"));
//   }
// });


// Page Loading Animation
// $(window).load(function () {
//   $(".loading").fadeOut(300);
// });
